<template>
    <div class="col-12 pr30 whiteBack pt0">

        <div class="col-12 centerText pt10" v-if="isLoading">
            <img src="/images/AjaxLoader.gif" />
        </div>
        <div v-else>
            <div class="col-12" v-if="containsErrors && errorMessage">
                <div class="paragraph message-error">
                    {{ errorMessage }}
                </div>
            </div>

            <div class="col-12 p10 greyBack" v-if="!showForm">
                <div class="paragraph darkColor fontSmooth centerText col-12">
                    {{ message }}
                </div>
            </div>
            <div class="col-8" v-else>
                <input type="hidden" name="_token" :value="$store.state.csrfToken">
                <input type="hidden" id="contactform-recaptcha" name="recaptcha" value="" />

                <div class="col-12">
                    <label for="first_name" class="inputLabel">{{ label('shop.account.first_name') }}: <span class="redColor">*</span></label>
                    <input type="text" class="input mt5" id="first_name" v-model="formData.first_name" />
                    <div class="col-12  message-error" v-if="errors.has('first_name')" v-text="errors.get('first_name')"></div>
                </div>
                <div class="col-12 mt10">
                    <label for="last_name" class="inputLabel">{{ label('shop.account.last_name') }}: <span class="redColor">*</span></label>
                    <input type="text" class="input mt5" id="last_name" v-model="formData.last_name" />
                    <div class="col-12 message-error" v-if="errors.has('last_name')" v-text="errors.get('last_name')"></div>
                </div>

                <div class="col-12 mt10">
                    <label for="email" class="inputLabel">{{ label('shop.account.email') }}: <span class="redColor">*</span></label>
                    <input type="email" name="email" class="input mt5" id="email" v-model="formData.email" />
                    <div class="col-12 message-error" v-if="errors.has('email')" v-text="errors.get('email')"></div>
                </div>

                <div class="col-12 mt10">
                    <label for="phone" class="inputLabel">{{ label('shop.contact.phone') }}:</label>
                    <input type="text" class="input mt5" id="phone" v-model="formData.phone" />
                    <div class="col-12 message-error" v-if="errors.has('phone')" v-text="errors.get('phone')"></div>
                </div>

                <div class="col-12 mt10">
                    <label for="subject" class="inputLabel">{{ label('shop.contact.subject') }}: <span class="redColor">*</span></label>
                    <input type="text" class="input mt5" id="subject" v-model="formData.subject" />
                    <div class="col-12 message-error" v-if="errors.has('subject')" v-text="errors.get('subject')"></div>
                </div>

                <div class="col-12 mt10">
                    <label for="message" class="inputLabel">{{ label('shop.contact.message') }}: <span class="redColor">*</span></label>
                    <textarea rows="4" cols="50" class="input mt5" id="message" v-model="formData.message"></textarea>
                    <div class="col-12 message-error" v-if="errors.has('message')" v-text="errors.get('message')"></div>
                    <span class="clearFix"></span>
                    <button type="submit" @click="sendForm()" class="button blue mt10 floatRightI"><span>{{ label('shop.contact.send') }}</span></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Errors from '../../errors';
import translations from "../mixins/translations";

export default {
    mixins: [translations,],
    props: {
        action: {
            type: String,
            required: false,
        },
        recaptchaKey: {
            type: String,
            required: true,
        }
    },
    data () {
        return {
            currentAction: '/api/site/form/contact/',
            isLoading: false,
            showForm: true,
            containsErrors: false,
            errorMessage: "",
            errors: new Errors,
            message: "",
            formData: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                subject: '',
                message: '',
                recaptcha: '',
            },
            recaptchaLoaded: false,
        }
    },
    methods: {
        sendForm() {
            this.isLoading = true;
            this.errors.clear();

            let vue = this;

            let key = this.recaptchaKey;
            grecaptcha.ready(function() {
                grecaptcha.execute(key, {action: 'contactform'}).then(function(token) {
                    vue.formData.recaptcha = token;

                    axios.post(vue.currentAction, vue.formData)
                    .then(response => {
                        window.location.href = "/contact-bedankt/"
                    }).catch(error => {
                        if (error.response.status == 422) {
                            vue.errors.record(error.response.data.errors);
                        } else {
                            vue.errorMessage = error.response.message;
                        }

                        vue.containsErrors = true;

                        vue.setRecaptchaKey();
                    });
                });
            });

            this.isLoading = false;
        },
        setRecaptchaKey() {
            //recaptcha
            if(!this.recaptchaLoaded){
                let head = document.getElementsByTagName('head')[0];
                let script = document.createElement('script');
                script.type = 'text/javascript';

                script.src = "https://www.google.com/recaptcha/api.js?render=6Lfh5VEcAAAAAEXBTNqkfvMj3GvAFhRU1IZiAYZp";
                head.appendChild(script);

                this.recaptchaLoaded = true;
            }
        }
    },
    computed: {
    },
    mounted() {
        if (this.action) {
            this.currentAction = this.action;
        }

        this.setRecaptchaKey();
    }
}
</script>
